import React from "react";
import { Outlet } from "react-router-dom";
const OrderManagementIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default OrderManagementIndex;
